<div class="map-wrapper" [style]="{ 'min-height': _height }">
    <img id="hatch" style="display: none" [src]="hatchImage" />
    <div class="export-menu" *ngIf="downloadable">
        <div mat-icon-button [matMenuTriggerFor]="menu">
            <i class="icon icon-download"></i>
        </div>

        <mat-menu #menu="matMenu" class="map-dropdown">
            <button mat-menu-item (click)="export()">Download PNG</button>
            <button
                mat-menu-item
                (click)="export(index)"
                *ngFor="let layer of layers; let index = index">
                Download shapefile -
                {{ legendConfig && legendConfig[index] ? legendConfig[index].title : '' }}
            </button>
        </mat-menu>
    </div>
    <div [id]="mapId" class="map" [style]="{ height: _height }"></div>
</div>
